module.exports = __webpack_public_path__ + "img/邻里3.9f419b2a.png";